module.exports = __webpack_public_path__ + "img/home-service-gs.d4d959ae.png";